import { hash } from '@ember/helper';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export enum EditingStoppedReason {
  Cancelled = 'cancelled',
  Saved = 'saved',
  SaveFailed = 'save-failed',
}

export interface EditingContext {
  isEditing: boolean;
  editingStarted: () => void;
  editingStopped: (reason: EditingStoppedReason) => void;
}

export interface EditContextSignature {
  Args: {
    /**
     * The callback to call when editing is started.
     */
    onEditingStarted?: () => void;

    /**
     * The callback to call when editing is stopped.
     */
    onEditingStopped?: (reason: EditingStoppedReason) => void;
  };
  Blocks: {
    default: [context: EditingContext];
  };
}

export class EditContext extends Component<EditContextSignature> {
  @tracked isEditing = false;

  editingStarted = () => {
    this.isEditing = true;
    this.args.onEditingStarted?.();
  };

  editingStopped = (reason: EditingStoppedReason) => {
    this.isEditing = false;
    this.args.onEditingStopped?.(reason);
  };

  <template>
    {{yield
      (hash
        isEditing=this.isEditing
        editingStarted=this.editingStarted
        editingStopped=this.editingStopped
      )
    }}
  </template>
}
